/**
 * 获取当前浏览器信息
 * @returns {object} 包含浏览器名称和版本号的对象.
 */
export function getBrowserInfo() {
	var _userAgent$match, _userAgent$match2, _userAgent$match3, _userAgent$match4, _userAgent$match5;
	const userAgent = navigator.userAgent.toLowerCase();
  
	// 检查userAgent以确定浏览器类型
	const isIE = userAgent.includes('msie') || userAgent.includes('trident');
	const isEdge = userAgent.includes('edg/');
	const isFirefox = userAgent.includes('firefox/');
	const isChrome = userAgent.includes('chrome/');
	const isSafari = userAgent.includes('safari/') && !isChrome;
	const ieVersion = isIE && ((_userAgent$match = userAgent.match(/(msie|rv:)\s?([\d.]+)/)) === null || _userAgent$match === void 0 ? void 0 : _userAgent$match[2]);
	const edgeVersion = isEdge && ((_userAgent$match2 = userAgent.match(/edg\/([\d.]+)/)) === null || _userAgent$match2 === void 0 ? void 0 : _userAgent$match2[1]);
	const firefoxVersion = isFirefox && ((_userAgent$match3 = userAgent.match(/firefox\/([\d.]+)/)) === null || _userAgent$match3 === void 0 ? void 0 : _userAgent$match3[1]);
	const chromeVersion = isChrome && ((_userAgent$match4 = userAgent.match(/chrome\/([\d.]+)/)) === null || _userAgent$match4 === void 0 ? void 0 : _userAgent$match4[1]);
	const safariVersion = isSafari && ((_userAgent$match5 = userAgent.match(/version\/([\d.]+)/)) === null || _userAgent$match5 === void 0 ? void 0 : _userAgent$match5[1]);
	const notVersion = "";
	// 从userAgent中提取版本号
	const version = ieVersion || edgeVersion || firefoxVersion || chromeVersion || safariVersion || notVersion;
  
	// 根据浏览器类型返回名称
	const name = isIE && 'ie' || isEdge && 'Edge' || isFirefox && 'Firefox' || isChrome && 'Chrome' || isSafari && 'Safari' || '';
  
	// 返回包含浏览器名称和版本号的对象
	return {
	  name,
	  version
	};
  }